import React from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import { withRouter } from 'react-router-dom';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import { cycle } from '../../store/Cycle';
import { capfirst } from '../../utils';


const styles = theme => ({
  container: {
    backgroundColor: theme.palette.primary.dark,
    color: 'rgba(255, 255, 255, 0.5)',
  },
  disabledContainer: {
    opacity: 0.3,
    pointerEvents: 'none',
  },
  button: {
    color: 'rgba(255, 255, 255, 0.5)',
    height: '100%',
    padding: theme.spacing(1),
    minWidth: 'auto',
  },
  label: {
    padding: theme.spacing(1),
    minWidth: 75,
  },
  month: {
    color: 'white',
  },
});


@withStyles(styles)
@withRouter
@observer
class CycleSelector extends React.Component {
  static propTypes = {
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    disabled: false,
  };

  @observable updating = false;

  componentDidMount() {
    this.onLocationChange();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if ((this.props.location !== prevProps.location) && !this.updating) {
      this.onLocationChange();
    }
  }

  onLocationChange() {
    const params = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    if (params['cycle_year']) {
      cycle.year = parseInt(params['cycle_year']);
    }
    if (params['cycle_month']) {
      cycle.month = parseInt(params['cycle_month']);
    }
    cycle.updateStorage();
  }

  updateLocation() {
    const { history } = this.props;
    history.push({
      search: qs.stringify(cycle.params, { arrayFormat: 'repeat' }),
    });
    cycle.updateStorage();
  }

  prev = () => {
    this.updating = true;
    cycle.decrement();
    this.updateLocation();
    this.updating = false;
  };

  next = () => {
    this.updating = true;
    cycle.increment();
    this.updateLocation();
    this.updating = false;
  };

  render() {
    const { disabled, classes } = this.props;
    return (
      <Grid container className={`${classes.container} ${disabled ? classes.disabledContainer : ''}`}>
        <Grid item>
          <Button size="small" onClick={this.prev} className={classes.button}>
            <ChevronLeftIcon />
          </Button>
        </Grid>
        <Grid item className={classes.label}>
          <Typography variant="subtitle1" align="center" className={classes.month}>
            {capfirst(cycle.shortMonth)}
          </Typography>
          <Typography align="center">{cycle.shortYear}</Typography>
        </Grid>
        <Grid item>
          <Button size="small" onClick={this.next} className={classes.button}>
            <ChevronRightIcon />
          </Button>
        </Grid>
      </Grid>
    );
  }
}


export default CycleSelector;
